import { Box, Button, Checkbox, FormControlLabel, IconButton } from '@mui/material'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import React, { useState } from 'react'
import AIFeedback from '../../Modals/AIFeedback';
import { Navigate } from 'react-router-dom';

function DemoStep7() {
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
  
  return (
    <>
      <div className="s_head text_center hd_6">
        <h2>Review Your Profile</h2>
      </div>
      <div className="form">
        <div className="gap_p">
          <div className="control_group w_100">
            <div className="border_box">
              <label>Email <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <p>johndoe@yopmail.com</p>
            </div>
          </div>
          <div className="control_group w_50">
            <div className="border_box">
              <label>Uploaded Trade License <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <div className="doc_preview">
                <ImageOutlinedIcon /> <p>trade-license.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
            </div>
          </div>
          <div className="control_group w_50">
            <div className="border_box">
              <label>Upload Memorandum of Association (MOA) <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <div className="doc_preview">
                <ImageOutlinedIcon /> <p>memorandum-of-association.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
            </div>
          </div>
          <div className="control_group w_100">
            <div className="border_box">
              <label>Tell us about your business <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi minima quis labore eveniet dolor deserunt veritatis necessitatibus maiores natus nulla.</p>
            </div>
          </div>
          <div className="control_group w_100">
            <div className="border_box">
              <label>Uploaded Sample Product Images <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <div className="uploaded_images" style={{ marginTop: "10px" }}>
                <div className="inner gap_m inner_flx">
                  <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                </div>
              </div>
            </div>
          </div>
          <div className="control_group w_100">
            <div className="border_box">
              <label>Product Video <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <p><a href="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4">http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4</a></p>
            </div>
          </div>
          <div className="control_group w_100">
            <div className="border_box">
              <label>Social Media Links <Box component="a"><img src="/static/images/edit_icon.svg" alt="Icon" /></Box></label>
              <ul className="social_list">
                <li>
                  <IconButton className='btn_rounded primary'><img src="/static/images/twitter_icon.svg" alt="Icon" /></IconButton>
                  <p><a href="https://www.facebook.com/">https://www.facebook.com/</a></p>
                </li>
                <li>
                  <IconButton className='btn_rounded primary'><img src="/static/images/facebook_icon.svg" alt="Icon" /></IconButton>
                  <p><a href="https://www.twitter.com/">https://twitter.com/</a></p>
                </li>
                <li>
                  <IconButton className='btn_rounded primary'><img src="/static/images/instagram_icon.svg" alt="Icon" /></IconButton>
                  <p><a href="https://www.instagram.com/">https://www.instagram.com/</a></p>
                </li>
                <li>
                  <IconButton className='btn_rounded primary'><img src="/static/images/ticktok_icon.svg" alt="Icon" /></IconButton>
                  <p><a href="https://www.tiktok.com/">https://www.tiktok.com/</a></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="verify_box uht_spc">
          <Button className="btn btn_primary" style={{ marginBottom: "30px" }} onClick={()=> setOpenSuccessModal(true)}><img src="/static/images/ai_icon.svg" alt='Icon' /> Verify with AI</Button>
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="">By proceeding, I confirm that:</label>
            </div>
            <div className="control_group w_100">
              <FormControlLabel control={<Checkbox defaultChecked />} label="The information and documents I’ve shared are true and current." />
            </div>
            <div className="control_group w_100">
              <FormControlLabel control={<Checkbox defaultChecked />} label="I hold the rights to all content I upload, including product images and videos." />
            </div>
            <div className="control_group w_100">
              <FormControlLabel control={<Checkbox defaultChecked />} label="I agree to the [Vendor Terms & Conditions] and [Privacy Policy]." />
            </div>
          </div>
        </div>
      </div>
      <AIFeedback
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        setOpen={setOpenSuccessModal}
      />
    </>
  )
}

export default DemoStep7